var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{staticClass:"white--text",attrs:{"bottom":"","color":"black"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({staticClass:"mx-1",on:{"click":_vm.onClick}},on),[_vm._v(" "+_vm._s(_vm.icon)+" ")])]}}])},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }